import { CircularProgress, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { Device } from "../../../../../../API";
import LiveViewSidebarPlayer from "./LiveViewSidebarPlayer";

type LiveViewTimelapseViewerProps = {
  device: Device;
  hlsUrl: string | null;
  statusMessage: string;
  loading: boolean;
};

const LiveViewTimelapseViewer = ({
  device,
  hlsUrl,
  statusMessage,
  loading,
}: LiveViewTimelapseViewerProps): JSX.Element => {
  if (hlsUrl) {
    return (
      <LiveViewSidebarPlayer device={device} hlsUrl={hlsUrl} showControls />
    );
  }

  return (
    <Box
      sx={{
        width: "100%",
        height: "280px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme => theme.palette.otherBackground?.main,
        px: 2,
        textAlign: "center",
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {statusMessage}
      </Typography>

      {loading && <CircularProgress />}
    </Box>
  );
};

export default LiveViewTimelapseViewer;
